var bW = document.documentElement.clientWidth;
var bH = document.documentElement.clientHeight;
var scrollTop = $(window).scrollTop();
$(window).on('resize', function () {
  bW = document.documentElement.clientWidth;
  bH = document.documentElement.clientHeight;
})


//ham Menu
$('.c-ham__btn').on('click', function () {
  $('.c-ham__btn .ham').toggleClass('active');
  if ($('.c-ham__btn .ham').hasClass('active')) {
    $('.c-ham__menu').addClass('active');
    $('body').addClass('menuactive');
  } else {
    $('.c-ham__menu').removeClass('active');
    $('body').removeClass('menuactive');
  }
})


//pc nav sublist
if ($(".c-nav__list__li--dropdown")) {
  var link = $('.c-nav__list__li--dropdown');
  link.hover(function () {
    link.not(this).removeClass('active');
    link.not(this).children('.c-nav__sublist').removeClass('active');
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).children('.c-nav__sublist').removeClass('active');
      return false;
    } else {
      $(this).addClass('active');
      $(this).children('.c-nav__sublist').addClass('active');
      return false;
    }
  });
}


//smooth scroll
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});


//top slider
if ($(".p-kv-top__slider")) {
  var topSlider = new Swiper('.p-kv-top__slider__inner', {
    speed: 2000,
    autoplay: {
      delay: 4000,
    },
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    effect: 'fade',
    pagination: {
      el: '.p-kv-top__pagenation',
      type: 'bullets',
    },
  })
}



window.addEventListener('load', function(){
  deSVG('.desvg', true);
});

$('body').addClass('show');